module.exports = __webpack_public_path__ + "img/5.f3279024.webp";